// extracted by mini-css-extract-plugin
export default {"summaryDescription":"styles_summaryDescription__kSPq8"};